/* eslint-disable react/forbid-component-props */
import classNames from 'classnames';
import React from 'react';

import commonStyles from '@css/outline.scss';

import { isAdvancedAccessibilityEnabled } from '@services/featureFlags';

import styles from './table.scss';

function mainContainerStyles({
  containerStyles,
  hasBorderStyle,
  hasFixedLayoutStyle,
  hasHoverStyle
}) {
  return classNames(styles.table, containerStyles, {
    [commonStyles.hasBorder]: hasBorderStyle,
    [commonStyles.hasHover]: hasHoverStyle,
    [styles.table_hasFixedLayout]: hasFixedLayoutStyle
  });
}

interface TableProps {
  id?: string;
  ariaHidden?: boolean;
  ariaLabel?: string;
  ariaRole?: string;
  children?: React.ReactNode;
  containerStyles?: string;
  containerElement?: string;
  hasBorderStyle?: boolean;
  hasFixedLayoutStyle?: boolean;
  hasHoverStyle?: boolean;
  onClick?: (...args: unknown[]) => unknown;
  onMouseLeave?: (...args: unknown[]) => unknown;
  onMouseOut?: (...args: unknown[]) => unknown;
  onMouseOver?: (...args: unknown[]) => unknown;
  shouldRender?: boolean;
}

export default function Table({
  id,
  ariaHidden,
  ariaRequired,
  ariaLabel,
  ariaRole,
  children,
  containerElement = 'div',
  containerStyles,
  hasBorderStyle,
  hasFixedLayoutStyle = true,
  hasHoverStyle,
  onClick,
  onMouseLeave,
  onMouseOut,
  onMouseOver,
  shouldRender = true
}: TableProps) {
  if (!shouldRender) return null;

  const tableContainerStyles = mainContainerStyles({
    containerStyles,
    hasBorderStyle,
    hasFixedLayoutStyle,
    hasHoverStyle
  });
  const Container = containerElement;
  const ariaRequiredProp =
    isAdvancedAccessibilityEnabled() && ariaRequired ? { 'aria-required': true } : {};
  return (
    <Container
      id={id}
      aria-hidden={ariaHidden}
      aria-label={ariaLabel}
      {...ariaRequiredProp}
      className={tableContainerStyles}
      onClick={onClick}
      onMouseLeave={onMouseLeave}
      onMouseOut={onMouseOut}
      onMouseOver={onMouseOver}
      role={ariaRole}>
      {children}
    </Container>
  );
}
